/*
 * @Author: Json Chen
 * @Date: 2021-07-22 14:24:21
 * @LastEditTime: 2021-11-03 11:28:20
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/logistic.ts
 */

import { get, post } from '@/src/tools/server';

export const getLogisticsSetting = (salesChannelUuid, params?) => {
  return get<any>(
    `/portal/salesChannelSetting/logisticsSetting/${salesChannelUuid}`,
    params || {},
  );
};
export const setLogisticsSetting = (data, params?) => {
  return post<any>(
    `/portal/salesChannelSetting/logisticsSetting`,
    data,
    params || {},
  );
};

export const getDeliveryMethodByWarehouse = (storeWarehouseLocationUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/logisticsSetting/deliveryMethod/${storeWarehouseLocationUuid}`,
    {},
  );
};

export const getParcelLockers = (storeWarehouseUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/logisticsSetting/parcelLocker/${storeWarehouseUuid}`,
    {},
  );
};

export const getLogisticsMethod = (storeWarehouseUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/logisticsSetting/logisticsMethod/${storeWarehouseUuid}`,
    {},
  );
};
